/* 首頁 */
export const ROOT_PAGE_HOME = '/home';

/* 服務 */
export const ROOT_PAGE_SERVICE = '/service';

/* 服務 : 第一層 */
export const ROOT_PAGE_SERVICE_OVERVIEW = '/overview';
export const ROOT_PAGE_SERVICE_DETAIL = '/:id';
export const ROOT_PAGE_SERVICE_DETAIL_TYPE = '/:type';

/* 專案 */
export const ROOT_PAGE_PROJECT = '/project';

/* 專案 : 第一層 */
export const ROOT_PAGE_PROJECT_OVERVIEW = '/overview';
export const ROOT_PAGE_PROJECT_DETAIL = '/:id';
export const ROOT_PAGE_PROJECT_DETAIL_TYPE = '/:type';

/* 聯絡我們 */
export const ROOT_PAGE_CONTACT = '/contact';

/* 使用者管理 */
export const ROOT_PAGE_ACCOUNT = '/account';

/* 使用者管理 : 第一層 */
export const ROOT_PAGE_ACCOUNT_OVERVIEW = '/overview';
export const ROOT_PAGE_ACCOUNT_DETAIL = '/:id';
export const ROOT_PAGE_ACCOUNT_DETAIL_TYPE = '/:type';
